var _path, _mask, _g, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M16.237 33.184c.871 0 1.579-.707 1.579-1.579v-10.19l1.882 2.028c.31.334.734.504 1.158.504.384 0 .77-.139 1.074-.421.64-.594.675-1.593.082-2.232l-4.618-4.974c-.598-.643-1.717-.643-2.315 0l-4.618 4.974c-.593.64-.557 1.638.083 2.232.638.592 1.638.556 2.232-.083l1.882-2.028v10.19c0 .872.707 1.579 1.579 1.579M32.027 15.816c-.872 0-1.58.708-1.58 1.58v10.19l-1.882-2.028c-.594-.639-1.593-.676-2.231-.082-.64.593-.676 1.592-.082 2.23l4.618 4.974c.298.323.718.505 1.157.505.438 0 .858-.182 1.156-.505l4.619-4.973c.593-.639.557-1.638-.083-2.231-.637-.594-1.637-.558-2.23.082l-1.883 2.027v-10.19c0-.871-.708-1.579-1.58-1.579",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "oeqojgrgba",
    width: 42,
    height: 26,
    x: 4,
    y: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4 2h41.842v25.83H4V2z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#oeqojgrgba)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M5.579 27.83c.872 0 1.579-.707 1.579-1.579V7.526c0-1.306 1.063-2.368 2.368-2.368h30.79c1.306 0 2.368 1.062 2.368 2.368 0 .872.708 1.58 1.58 1.58.871 0 1.578-.708 1.578-1.58C45.842 4.48 43.363 2 40.316 2H9.526C6.48 2 4 4.479 4 7.526v18.725c0 .872.707 1.58 1.579 1.58",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b5b58cnuub",
    width: 42,
    height: 33,
    x: 4,
    y: 14,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4 14.78h41.842V47H4V14.78z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b5b58cnuub)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M44.263 14.78c-.871 0-1.579.708-1.579 1.58v25.114c0 1.306-1.062 2.368-2.368 2.368H9.526c-1.305 0-2.368-1.062-2.368-2.368v-8.221c0-.872-.707-1.579-1.579-1.579S4 32.381 4 33.253v8.22C4 44.522 6.479 47 9.526 47h30.79c3.047 0 5.526-2.479 5.526-5.526V16.36c0-.872-.707-1.58-1.579-1.58",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLift);
export default __webpack_public_path__ + "static/media/lift.fa71bb8c0fd914383bb8690a770b408f.svg";
export { ForwardRef as ReactComponent };